import { Component, EventEmitter, Input, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { PaginacaoDto } from '@core/dto/paginacao-dto';
import { PaginatorCustomDirective } from '@shared/components/paginator-custom/paginator-custom.directive';

@Component({
  selector: 'app-paginator-custom-dinamic',
  templateUrl: './paginator-custom-dinamic.component.html',
  styleUrls: ['./paginator-custom-dinamic.component.scss']
})
export class PaginatorCustomDinamicComponent extends PaginatorCustomDirective implements OnInit, OnChanges {
  @Input() paginationId = 'pagination';
  @ViewChild('p') p: any;
  @Input() public items: Array<any>;
  @Input() public itemsPerPage: number;
  @Input() public stylesClass: '';
  @Output() public pageChange: EventEmitter<number> = new EventEmitter();

  @Input() pageResponse: PaginacaoDto<any>;
  @Input() public currentPage: number;
  @Input() public pageCount: number;
  @Input() public total: number;
  public pages: Array<number> = new Array<number>();
  public count: number;

  @Output() public itemsPerPageChange = new EventEmitter<number>();
  @Input() itemsPerPageOptions = [50, 100, 200];

  ngOnInit() {
    if (!this.itemsPerPageOptions || this.itemsPerPageOptions.length === 0) {
      this.itemsPerPageOptions = [50, 100, 200];
    }
    if (!this.itemsPerPageOptions.includes(this.itemsPerPage)) {
      this.itemsPerPage = this.itemsPerPageOptions[0];
    }
  }

  public getTotalPerPage(page) {
    let current: number;
    let total: number;
    let itemsPerPage: number;

    if (this.pageResponse) {
      current = this.pageResponse?.currentPage ?? 0;
      total = this.pageResponse?.total ?? 0;
      itemsPerPage = this.pageResponse?.numPerPage ?? 0;
    } else if (page) {
      current = page.getCurrent();
      total = page.getTotalItems();
      itemsPerPage = this.itemsPerPage;
    }

    const start = (current - 1) * Number(itemsPerPage) + 1;
    const end = Math.min(start + Number(itemsPerPage) - 1, total);
    return end || '0';
  }

  public changeEvent(page): void {
    this.pageChange.emit(page);
  }

  public getTotalItems(): number {
    return this.pageResponse ? this.pageResponse.total : this.items.length ;
  }

  public onItemsPerPageChange() {
    this.itemsPerPageChange.emit(this.itemsPerPage);
  }
}
